import { AlertTriangle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { backLabelFor, type PropertyEntry } from './propertyEntry';

interface Props {
  onRetry: () => void;
  onBackToProperties: () => void;
  /** Which surface is rendering this — drives the label AND the sentence. */
  entry?: PropertyEntry;
  /** What failed to load (DV-2849 PR 3): the property record, or its photos
   *  (the workspace's photosets fetch). Changes only the sentence. */
  subject?: 'property' | 'photos';
}

export function PropertyLoadError({ onRetry, onBackToProperties, entry = 'account', subject = 'property' }: Props) {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <AlertTriangle className="h-12 w-12 mx-auto text-muted-foreground" aria-hidden="true" />
        <Typography as="h1" variant="heading-lg" className="font-semibold">
          Something Went Wrong
        </Typography>
        <Typography className="text-muted-foreground">
          We couldn&apos;t load{' '}
          {subject === 'photos' ? <>this property&apos;s photos</> : 'this property'}. Try
          again, or return to{' '}
          {entry === 'global-orders' ? 'Global Orders' : 'your properties'}.
        </Typography>
        <div className="flex items-center justify-center gap-2 pt-2">
          <Button variant="outline" onClick={onBackToProperties}>{backLabelFor(entry)}</Button>
          <Button variant="default" onClick={onRetry}>Try Again</Button>
        </div>
      </div>
    </div>
  );
}
